import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CommonDropdownControlDirective } from 'app/shared/directives/control/common-dropdown-control.directive';

@Component({
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommonDropdownComponent)
    }
  ],
  selector: 'kh-common-dropdown',
  styleUrls: ['./common-dropdown.component.less'],
  templateUrl: './common-dropdown.component.html',
  standalone: false
})
export class CommonDropdownComponent<TItem, TValue> extends CommonDropdownControlDirective<TItem, TValue> {
}
